import styled, { css, keyframes } from "styled-components";

export const IconContainer = styled.img`
	align-items: center;
	display: flex;
	justify-content: center;
	object-fit: contain;
	width: 25px;
	height: auto;
`;

const shake = keyframes`
  0% { transform: rotate(0deg); }
  1.5% { transform: rotate(-20deg); }
  2% { transform: rotate(20deg); }
  3.5% { transform: rotate(-20deg); }
  4% { transform: rotate(20deg); }
  5.5% { transform: rotate(-10deg); }
  6% { transform: rotate(10deg); }
  7% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); } 
`;

export const SuggestedsShake = styled.div`
	display: inline-flex;
	transform-origin: center bottom;
	min-width: 30px;
	min-height: 30px;

	${({ $active }) =>
		$active &&
		css`
			animation: ${shake} 5s ease-in-out infinite;
		`}

	&:hover {
		${({ $active }) =>
			$active &&
			css`
				animation-duration: 2s;
			`}
	}
`;
